import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { getAuth, applyActionCode, verifyPasswordResetCode, confirmPasswordReset } from "firebase/auth";
import "../style.css";

function AccountAction() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const auth = getAuth();

  const [actionMode, setActionMode] = useState("");
  const [oobCode, setOobCode] = useState("");
  const [message, setMessage] = useState("");
  const [password, setPassword] = useState("");
  const [passwordResetSuccess, setPasswordResetSuccess] = useState(false);

  useEffect(() => {
    const mode = searchParams.get("mode");
    const code = searchParams.get("oobCode");

    if (!mode || !code) {
      setMessage("Invalid or missing action parameters.");
      return;
    }

    setActionMode(mode);
    setOobCode(code);

    if (mode === "verifyEmail") {
      handleEmailVerification(code);
    } else if (mode === "resetPassword") {
      handlePasswordResetValidation(code);
    }
  }, [searchParams]);

  // Handle Email Verification
  const handleEmailVerification = async (code) => {
    try {
      await applyActionCode(auth, code);
      setMessage("Email verified successfully! Redirecting to login...");
      setTimeout(() => navigate("/login"), 3000);
    } catch (error) {
      setMessage(`❌ Email verification failed: ${error.message}`);
    }
  };

  // Validate Password Reset Code Before Showing Form
  const handlePasswordResetValidation = async (code) => {
    try {
      await verifyPasswordResetCode(auth, code);
    } catch (error) {
      setMessage(`❌ Invalid or expired password reset link: ${error.message}`);
    }
  };

  // Handle Password Reset Submission
  const handlePasswordReset = async (e) => {
    e.preventDefault();
    try {
      await confirmPasswordReset(auth, oobCode, password);
      setPasswordResetSuccess(true);
      setMessage("Password has been successfully reset! Redirecting to login...");
      setTimeout(() => navigate("/login"), 3000);
    } catch (error) {
      setMessage(`❌ Failed to reset password: ${error.message}`);
    }
  };

  return (
    <div className="container">
      <div className="logo-container">
        <img src="https://storage.googleapis.com/kinova/Kinova_transparent.png" alt="Kinova Logo" />
      </div>
      <div className="login-card">
        <h2>{actionMode === "resetPassword" ? "Reset Password" : "Account Action"}</h2>

        {message && <p className="status-message">{message}</p>}

        {/* Show Password Reset Form if Needed */}
        {actionMode === "resetPassword" && !passwordResetSuccess && (
          <form onSubmit={handlePasswordReset}>
            <input
              type="password"
              placeholder="New Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <button type="submit" className="btn-primary">Reset Password</button>
          </form>
        )}
      </div>
    </div>
  );
}

export default AccountAction;
